module.exports = __webpack_public_path__ + "img/рз_13.501d35b3.png";